var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M458.667 0c-29.419 0-53.333 23.936-53.333 53.333 0 10.859 3.285 20.928 8.875 29.376l-331.52 331.52c-8.427-5.611-18.496-8.896-29.355-8.896C23.915 405.333 0 429.269 0 458.667S23.915 512 53.333 512c29.419 0 53.333-23.936 53.333-53.333 0-10.859-3.285-20.928-8.875-29.376l331.52-331.52c8.427 5.611 18.496 8.896 29.355 8.896 29.419 0 53.333-23.936 53.333-53.333S488.085 0 458.667 0zM53.333 490.667c-17.643 0-32-14.357-32-32s14.357-32 32-32c8.704 0 16.576 3.499 22.336 9.152.085.085.107.213.213.299.107.085.213.107.299.213 5.653 5.76 9.152 13.632 9.152 22.336 0 17.642-14.357 32-32 32zM458.667 85.333c-8.704 0-16.576-3.499-22.336-9.152-.085-.085-.107-.213-.213-.299s-.213-.107-.299-.213c-5.653-5.76-9.152-13.632-9.152-22.336 0-17.643 14.357-32 32-32s32 14.357 32 32-14.358 32-32 32z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.23b58e179bb88b5317d56d1ac44cdb2b.svg";
export { ForwardRef as ReactComponent };